<template>
  <v-data-table
    :headers="headers"
    :items="batchPrintingVerifications"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="BatchPrintingVerification-button-new"
          @click="$router.push({
            name: 'processing-EditBatchPrintingVerification'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditBatchPrintingVerification',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListBatchPrintingVerification',
  module: 'BatchPrintingVerification',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('batchPrintingVerifications', ['batchPrintingVerifications']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('document'),
          value: 'document',
        },
        {
          text: this.$$t('docNumber'),
          value: 'docNumber',
        },
        {
          text: this.$$t('reviewed'),
          value: 'reviewed',
        },
        {
          text: this.$$t('revision'),
          value: 'revision',
        },
        {
          text: this.$$t('approved'),
          value: 'approved',
        },
        {
          text: this.$$t('distributionApprovedAsControlledCopy'),
          value: 'distributionApprovedAsControlledCopy',
        },
        {
          text: this.$$t('date'),
          value: 'date',
        },
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('notes'),
          value: 'notes',
        },
        {
          text: this.$$t('brandingCode'),
          value: 'brandingCode',
        },
        {
          text: this.$$t('pieces'),
          value: 'pieces',
        },
        {
          text: this.$$t('drainweightCans'),
          value: 'drainweightCans',
        },
        {
          text: this.$$t('drainweightCansB'),
          value: 'drainweightCansB',
        },
        {
          text: this.$$t('bestBeforeDate'),
          value: 'bestBeforeDate',
        },
        {
          text: this.$$t('factoryCode'),
          value: 'factoryCode',
        },
        {
          text: this.$$t('productionBatchCode'),
          value: 'productionBatchCode',
        },
        {
          text: this.$$t('farmCode'),
          value: 'farmCode',
        },
        {
          text: this.$$t('requestedByName'),
          value: 'requestedByName',
        },
        {
          text: this.$$t('requestedBySignature'),
          value: 'requestedBySignature',
        },
        {
          text: this.$$t('printedEndApprovedByName'),
          value: 'printedEndApprovedByName',
        },
        {
          text: this.$$t('printEndApprovedBySignature'),
          value: 'printEndApprovedBySignature',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_batchPrintingVerifications();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('batchPrintingVerifications', ['LOAD_batchPrintingVerifications', 'DELETE_batchPrintingVerification']),
    /** Delete BatchPrintingVerification from the collection
     */
    async remove(BatchPrintingVerification) {
      this.isLoading = true;
      await this.DELETE_BatchPrintingVerification(BatchPrintingVerification);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# BatchPrintingVerification example

'''js
<BatchPrintingVerification />
'''
</docs>
